import { all, takeEvery } from 'redux-saga/effects';
import { ACTIONS } from '../types';
import {
  makeBetsAreaBetSaga,
  makeRaceTrackBetSaga,
  makeStraightBetSaga,
  placeBetSaga,
} from './placeBetSaga';
import { setRaceTrackSelectionSaga } from './setRaceTrackSelection';
import { cancelLastBetSaga } from './cancelLastBetSaga';
import { cancelAllBetsSaga } from './cancelAllBetsSaga';

export function* rouletteBetRootSaga() {
  yield all([takeEvery(ACTIONS.PLACE_BET, placeBetSaga)]);
  yield all([takeEvery(ACTIONS.MAKE_BET_AREA_BET, makeBetsAreaBetSaga)]);
  yield all([takeEvery(ACTIONS.MAKE_RACE_TRACK_BET, makeRaceTrackBetSaga)]);
  yield all([takeEvery(ACTIONS.MAKE_STRAIGHT_BET, makeStraightBetSaga)]);
  yield all([takeEvery(ACTIONS.SET_RACE_TRACK_SELECTION, setRaceTrackSelectionSaga)]);
  yield all([takeEvery(ACTIONS.CANCEL_LAST_BET, cancelLastBetSaga)]);
  yield all([takeEvery(ACTIONS.CANCEL_ALL_BETS, cancelAllBetsSaga)]);
}
